<template>
  <v-container fluid>
    <stripe-simple
      v-if="brain.oneTime"
      :items="[brain.item]"
      :use-client-amount="brain.useClientAmount"
      :total-amount="brain.amount"
      :currency-icon="brain.item.currency_icon"
      :currency="brain.item.currency"
      @success="$emit('sayThankYou')"
    />
    <stripe-subscribe
      v-if="auth.set && !brain.oneTime"
      :item="brain.item"
      :auth="auth"
      :step="step"
      @success="$emit('sayThankYou')"
    />
  </v-container>
</template>

<script>
import StripeSimple from '../../../../payment/Simple'
import StripeSubscribe from '../../../../stripe/Subscribe'

export default {
  name: 'StepPayment',
  components: {
    StripeSimple,
    StripeSubscribe
  },
  props: {
    brain: {
      type: Object,
      default: ()=>{return {}}
    },
    step: {
      type: Number,
      default: ()=>null
    }
  },
}
</script>